import { useState, useEffect } from 'react';
import { ref as storageRef, getDownloadURL, getStorage } from 'firebase/storage';

const imageUrlCache = {}; 

const ImageLoader = ({ storagePath, className, style, onImageLoad }) => {
    const [imageUrl, setImageUrl] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Handler to be called when the <img> element successfully loads the data
    const handleImageLoad = () => {
        setLoading(false); // Image is loaded, set loading to false
        if (onImageLoad) {
            onImageLoad(); // Execute the callback function provided by the parent
        }
    };

    useEffect(() => {
        // 1. Reset state for new path
        setLoading(true);
        setError(null);
        setImageUrl(null);

        if (imageUrlCache[storagePath]) {
            setImageUrl(imageUrlCache[storagePath]);
            setLoading(false);
            return; // Exit if the URL is found in the cache
        }

        // 2. Create a reference to the file in Firebase Storage
        const storage = getStorage();
        const fileRef = storageRef(storage, storagePath);

        // 3. Get the public download URL
        getDownloadURL(fileRef)
            .then((url) => {
                imageUrlCache[storagePath] = url;
                setImageUrl(url);
                setLoading(false);
            })
            .catch((err) => { // eslint-disable-line no-unused-vars

                setError("Error loading image.");
                setLoading(false);
            });
    }, [storagePath]); // Re-run effect whenever the path changes

    if (loading) {
        return <div>Loading image...</div>;
    }

    if (error) {
        return <div style={{ color: 'red' }}>{error}</div>;
    }

    return (
        <img
            src={imageUrl}
            alt={`Visual aid for sentence`}
            className={className}
            style={style}
            onLoad={handleImageLoad}
        />
    );
};

export default ImageLoader;